export default __webpack_public_path__ + "static/media/_Abstract-Template.92fe6fc4.odt";